export const marketStatisticsRouter = [
  {
    path: "home",
    name: "marketStatisticsHome",
    component: () => import("@/views/marketStatistics/home"),
    meta: { title: "按产品分析（销售、毛利额）", disableBack: false },
    hidden: true,
  },
  {
    path: "variousProducts",
    name: "variousProducts",
    component: () => import("@/views/marketStatistics/variousProducts"),
    meta: { title: "各大类产品销售额占比", disableBack: false },
    hidden: true,
  },
  {
    path: "constructProducts",
    name: "constructProducts",
    component: () => import("@/views/marketStatistics/constructProducts"),
    meta: { title: "专业建设产品销售明细", disableBack: false },
    hidden: true,
  },
  {
    path: "summaryOfSales",
    name: "summaryOfSales",
    component: () => import("@/views/marketStatistics/summaryOfSales"),
    meta: { title: "销售汇总表(按用户类型分析)", disableBack: false },
    hidden: true,
  },
  {
    path: "salesStatement",
    name: "salesStatement",
    component: () => import("@/views/marketStatistics/salesStatement"),
    meta: { title: "销售人员销售情况表", disableBack: false },
    hidden: true,
  },
  {
    path: "salesAreaStatement",
    name: "salesAreaStatement",
    component: () => import("@/views/marketStatistics/salesAreaStatement"),
    meta: { title: "按区域销售额分析", disableBack: false },
    hidden: true,
  },
  {
    path: "contractSummary",
    name: "contractSummary",
    component: () => import("@/views/marketStatistics/contractSummary"),
    meta: { title: "各年度销售合同金额及签订合同数量情况表", disableBack: false },
    hidden: true,
  },
  {
    path: "tenSalesStatement",
    name: "tenSalesStatement",
    component: () => import("@/views/marketStatistics/tenSalesStatement"),
    meta: { title: "前十大客户销售额", disableBack: false },
    hidden: true,
  },
  {
    path: "saleChannelSummary",
    name: "saleChannelSummary",
    component: () => import("@/views/marketStatistics/saleChannelSummary"),
    meta: { title: "按销售渠道分析情况表", disableBack: false },
    hidden: true,
  },
];
